import classNames from "classnames";
import {
  Container,
  Heading3,
  Heading6,
  ImageLite,
  Paragraph,
  RenderIf,
} from "shared/components";
import { VIEW_MODES } from "shared/contexts/ViewMode";

import styles from "./Content025.module.scss";

export const Content025 = ({ payload }) => {
  const title = payload?.title ?? "";
  const name = payload?.name ?? "";
  const description = payload?.description ?? "";
  const phone = payload?.phone ?? "";
  const email = payload?.email ?? "";
  const photo = payload?.photo ?? {};
  const template = payload?.template ?? "light";

  return (
    <div className={classNames(styles.wrapper, styles[template])}>
      <Container>
        <div className={styles.block}>
          <RenderIf viewMode={VIEW_MODES.MOBILE}>
            <Heading3 className={styles.title}>{title}</Heading3>
          </RenderIf>
          <span className={styles.image}>
            <ImageLite image={photo} className={styles.photo} />
          </span>
          <div className={styles.content}>
            <RenderIf viewMode={VIEW_MODES.DESKTOP}>
              <Heading3 className={styles.title}>{title}</Heading3>
            </RenderIf>
            <Heading6 className={styles.name}>{name}</Heading6>
            <Paragraph color="grey" className={styles.description}>
              {description}
            </Paragraph>
            <div className={styles.contacts}>
              <a href={`tel:${phone}`} className={styles.detail}>
                {phone}
              </a>
              <a href={`mailto:${email}`} className={styles.detail}>
                {email}
              </a>
            </div>
          </div>
        </div>
      </Container>
    </div>
  );
};

export default Content025;
